import { ArrowRight } from "lucide-react";
import { GroupedApprovalPreviews } from "./GroupedApprovalPreviews";
import { partitionApprovalQueue } from "./approval-queue-periods";
import type { ShiftProductionFormListItem } from "../../../shared/shift-production-form/contracts";

export function ApprovalQueuePanel({
  title, actorName, items, total, busy, phase, error, onOpen, onReload, onLogout,
}: {
  title: string;
  actorName: string;
  items: ShiftProductionFormListItem[];
  total: number;
  busy: boolean;
  phase: "loading" | "ready" | "error";
  error: string | null;
  onOpen: (id: string) => void;
  onReload: () => void;
  onLogout?: () => void;
}) {
  const loading = phase === "loading";
  const groups = partitionApprovalQueue(items);
  const first = groups.daily[0] ?? groups.overdue[0] ?? groups.other[0];
  return (
    <section className="approval-queue-overview" aria-label={title} aria-busy={loading}>
      <header className="approval-queue-overview-header">
        <h2>{loading ? "Bekleyen formlar yükleniyor…" : phase === "error" ? "Onay kuyruğu açılamadı" : total ? <><strong>{total}</strong> form onayınızı bekliyor</> : "Bekleyen onayınız yok"}</h2>
        <div className="approval-queue-actions">
          <span className="approval-queue-username" title={actorName}>{actorName}</span>
          {onLogout ? <button className="approval-queue-logout" type="button" disabled={busy} onClick={onLogout}>Çıkış yap</button> : null}
          {first ? <button className="approval-queue-begin" type="button" disabled={busy || loading || phase !== "ready"} onClick={() => onOpen(first.id)}>İncelemeye başla <ArrowRight size={17} aria-hidden="true" /></button> : null}
        </div>
      </header>
      {phase === "error" ? <div className="approval-queue-message" role="alert"><p>{error}</p><button type="button" onClick={onReload}>Tekrar dene</button></div> : null}
      {phase === "ready" && !loading && items.length ? <>
        {groups.daily.length ? <section aria-label="Önceki günün formları"><h3>Önceki günün formları</h3><GroupedApprovalPreviews items={groups.daily} busy={busy} showEmptyShifts label="Önceki günün formları" onOpen={onOpen} /></section> : null}
        {groups.overdue.length ? <section aria-label="Önceki günlerden bekleyenler"><h3>Önceki günlerden bekleyenler</h3><GroupedApprovalPreviews items={groups.overdue} busy={busy} showEmptyShifts label="Önceki günlerden bekleyenler" onOpen={onOpen} /></section> : null}
        {groups.other.length ? <section aria-label="Diğer bekleyen formlar"><h3>Diğer bekleyen formlar</h3><GroupedApprovalPreviews items={groups.other} busy={busy} showEmptyShifts label="Diğer bekleyen formlar" onOpen={onOpen} /></section> : null}
      </> : null}
      {phase === "ready" && !loading && total > items.length && items.length > 0 ? <p className="approval-form-preview-more">İlk {items.length} form gösteriliyor. İncelemeye başladığınızda tüm formlar sırayla açılır.</p> : null}
    </section>
  );
}
